<template>
  <div class="text-left" style="height:570px; overflow-y:auto;">
    <h1>Update IDD+ Vouchers</h1>
    <b-row class="mt-5">
      <b-col cols="4">
        <b-spinner
          v-if="isLoading"
          type="grow"
          class="text-center"
          style="margin-top: 10%; position:absolute;"
          variant="primary"
        ></b-spinner>
        <b-table-simple :busy.sync="isLoading" rules="all" border="1">
          <tr>
            <td>Used vouchers</td>
            <td>
              <span class="data-value" id="used_vouchers">{{this.voucherDetail[0].used_credits}}</span>
            </td>
          </tr>
          <tr>
            <td>Remaining Vouchers in the Platform</td>
            <td v-if="this.voucherDetail[0].is_unlimited == 1">
              <span class="data-value" id="remaining_vouchers">unlimited</span>
            </td>
            <td v-else>
              <span
                class="data-value"
                id="remaining_vouchers"
              >{{this.voucherDetail[0].remaining_credits}}</span>
            </td>
          </tr>
          <tr>
            <td>Numbers of Vouchers to add</td>
            <td v-if="this.voucherDetail[0].is_unlimited == 1">
              <span class="data-value" id="remaining_vouchers">0</span>
            </td>
            <td v-else>
              <span
                class="data-value"
                id="number_of_vouchers"
              >{{this.voucherDetail[0].is_unlimited}}</span>
            </td>
          </tr>
          <tr>
            <td>Total Vouchers to be displayed</td>
            <td v-if="this.voucherDetail[0].is_unlimited == 1">
              <span class="data-value" id="remaining_vouchers">unlimited</span>
            </td>
            <td v-else>
              <span
                class="data-value"
                id="total_displayed"
              >{{this.voucherDetail[0].remaining_credits}}</span>
            </td>
          </tr>
        </b-table-simple>
      </b-col>
      <b-col cols="7" class="mr-4">
        <b-form-group :disabled="form.voucherNumber > 0">
          <b-form-checkbox v-model="form.isUnlimitedVoucher" value="1">Unlimited Vouchers</b-form-checkbox>
        </b-form-group>
        <b-form-group
          label="Indicate Number of Vouchers to add"
          :disabled="form.isUnlimitedVoucher == 1"
        >
          <b-input v-model="form.voucherNumber" type="number"></b-input>
        </b-form-group>
        <b-form-group label="Voucher Type">
          <b-form-radio-group
            v-model="$v.form.voucherType.$model"
            :state="$v.form.voucherType.$dirty ? !$v.form.voucherType.$error : null"
            :options="optionVoucherType"
          ></b-form-radio-group>
        </b-form-group>
        <b-button variant="outline-success" class="float-right" @click="submitVoucher">Submit</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-tabs content-class="mt-3">
          <b-tab title="Used Vouchers" active>
            <div class="table-top">
              <b-spinner
                v-if="isLoading"
                type="grow"
                class="text-center"
                style="margin-top: 10%; position:absolute;"
                variant="primary"
              ></b-spinner>
              <b-navbar toggleable="lg" type="dark" variant="light">
                <b-navbar-brand href="#" class="text-dark">
                  <strong>Used IDD+ Vouchers</strong>
                </b-navbar-brand>
                <b-navbar-nav class="ml-auto">
                  <b-nav-form>
                    <b-form-group
                      label-cols-sm="3"
                      label-align-sm="right"
                      label-size="sm"
                      label-for="filterInput"
                    >
                      <b-input-group size="sm">
                        <b-form-input
                          v-model="filter"
                          type="search"
                          id="filterInput"
                          placeholder="Type to Search"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-nav-form>
                </b-navbar-nav>
              </b-navbar>
            </div>
            <b-table
            class="mx-1"
            sticky-header="calc(100vh - 200px)"
            ref="table"
            bordered
            id="used-voucher-table"
            :busy.sync="isLoading"
            :items="usedVouchersProvider"
            :fields="fields"
            :filter="filter"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            responsive="sm"
            ></b-table>
            <b-row>
              <b-col cols="2">
                <b-form-select
                  v-model="perPage"
                  id="perPageSelect"
                  size="sm"
                  :options="pageOptions"
                ></b-form-select>
              </b-col>
              <b-col>
                <b-pagination
                  class="float-right"
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                  first-text="First"
                  prev-text="Prev"
                  next-text="Next"
                  last-text="Last"
                  aria-controls="my-table"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab title="Added Vouchers">
            <div class="table-top">
              <b-spinner
                v-if="isLoading"
                type="grow"
                class="text-center"
                style="margin-top: 10%; position:absolute;"
                variant="primary"
              ></b-spinner>
              <b-navbar toggleable="lg" type="dark" variant="light">
                <b-navbar-brand href="#" class="text-dark">
                  <strong>Added IDD+ Vouchers</strong>
                </b-navbar-brand>
                <b-navbar-nav class="ml-auto">
                  <b-nav-form>
                    <b-form-group
                      label-cols-sm="3"
                      label-align-sm="right"
                      label-size="sm"
                      label-for="filterInput"
                    >
                      <b-input-group size="sm">
                        <b-form-input
                          v-model="filter"
                          type="search"
                          id="filterInput"
                          placeholder="Type to Search"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-nav-form>
                </b-navbar-nav>
              </b-navbar>
            </div>
            <b-table
              responsive="sm"
              :sort-by.sync="sortBy"
              bordered
              striped
              hover
              :busy.sync="isLoading"
              :filter="filter"
              :per-page="perPage"
              :current-page="currentPage"
              :items="addedVouchersProvider"
              :fields="fields"
            ></b-table>
            <b-row>
              <b-col cols="2">
                <b-form-select
                  v-model="perPage"
                  id="perPageSelect"
                  size="sm"
                  :options="pageOptions"
                ></b-form-select>
              </b-col>
              <b-col>
                <b-pagination
                  class="float-right"
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                  first-text="First"
                  prev-text="Prev"
                  next-text="Next"
                  last-text="Last"
                  aria-controls="my-table"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
    <b-modal
      id="add-voucher-modal"
      ok-only
      ok-title="Close"
      no-close-on-backdrop
      hide-footer
      size="sm"
      v-model="showModal"
      scrollable
    >
      <template v-slot:modal-header="{ close }">
        <h5>Add Voucher</h5>
      </template>
      <div v-if="!submiting && !responseSuccess">
        <p>Are you sure you would like to add the voucher</p>
      </div>
      <div v-else-if="submiting && !responseSuccess">
        <p>Your Voucher is being submited......</p>
        <b-spinner type="grow" label="Loading..."></b-spinner>
      </div>

      <div v-else>
        <p class="my-2 text-center">
          Your voucher has been added successfully.
          <br />
        </p>
      </div>
      <div class="float-right">
        <b-button
          size="sm"
          variant="danger"
          class="mr-3"
          v-if="!submiting"
          @click="resetFormModal"
        >Close</b-button>
        <!-- Button with custom close trigger value -->
        <b-button
          size="sm"
          v-if="!responseSuccess"
          :disabled="submiting"
          variant="outline-success"
          @click="addVoucher"
        >Add & Save</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
// import { Helper } from "../../helpers";
// import AppHeader from "../../components/header/header";
import { HTTP } from "../../utils/HTTP";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "ClientProfileVouchers",
  mixins: [validationMixin],
  components: {},
  data() {
    return {
      sortDesc: false,
      voucherDetail: [],
      showModal: false,
      isLoading: false,
      submiting: false,
      responseSuccess: false,
      form: {
        voucherNumber: null,
        voucherType: null,
        isUnlimitedVoucher: null
      },
      optionVoucherType: [
        { value: 1, text: "Client Request" },
        { value: 2, text: "Complimentary" }
      ],
      pageOptions: [5, 10, 25, 50, 75, 100],
      sortBy: "id",
      currentPage: 1,
      perPage: 10,
      filter: "",
      totalRows: 0,
      fields: [
        {
          key: "date",
          label: "Date & Time",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "members_display_name",
          label: "Username",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "company_name",
          label: "Sub-Account",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "comp_name_eng",
          label: "Third Party Name",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "country",
          label: "Country",
          sortable: true,
          sortDirection: "desc"
        }
      ],
      responseData: []
    };
  },
  validations: {
    form: {
      voucherType: {
        required
      }
    }
  },
  mounted() {
    this.getCompaniesVoucherDetail();
  },
  computed: {
    rows() {
      return this.totalRows;
    }
  },
  methods: {
    async usedVouchersProvider() {
      let formData = {
        filter: this.filter,
        // sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
        company_id: this.$route.params.id
      };

      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let result = HTTP("post", "v1/getusedvoucherslist", formData, {
        Authorization: token
      });

      return result
        .then(response => {
          // // console.log(response);
          const items = response.data.data;
          this.isLoading = false;
          this.totalRows = response.data.count;
          return items;
        })
        .catch(error => {
          this.isLoading = false;
          return [error];
        });
    },
    async addedVouchersProvider() {
      let formData = {
        company_id: this.$route.params.id
      };

      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let result = HTTP("post", "v1/getaddedvoucherslist", formData, {
        Authorization: token
      });

      return result
        .then(response => {
          const items = response.data.data;
          this.isLoading = false;
          this.totalRows = response.data.count;
          return items;
        })
        .catch(error => {
          this.isLoading = false;
          return [error];
        });
    },
    async getCompaniesVoucherDetail() {
      let formData = {
        company_id: this.$route.params.id
      };
      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let result = HTTP("post", "v1/get-companies-voucher-detail", formData, {
        Authorization: token
      });

      return result
        .then(response => {
          this.voucherDetail = response.data;
          this.isLoading = false;
          return this.voucherDetail;
        })
        .catch(error => {
          this.isLoading = false;
          return [error];
        });
    },
    resetFormModal() {
      this.responseSuccess = false;
      this.submiting = false;
      this.isLoading = false;
      this.showModal = false;
    },
    submitVoucher() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.showModal = true;
    },
    addVoucherApiCall() {
      // const option = JSON.stringify(this.rowDataMultiChoice);
      this.formData = {
        voucher_type: this.form.voucherType,
        company_id: this.$route.params.id,
        number_of_vouchers: this.form.voucherNumber,
        member_id: localStorage.getItem("userId"),
        is_unlimited: this.form.isUnlimitedVoucher
      };
      this.submiting = true;
      this.isLoading = true;
      const URI = "v1/addvoucher",
        headers = {
          Authorization: "Bearer " + localStorage.getItem("accessToken")
        };
      const Result = HTTP("post", URI, this.formData, headers, null, true);
      return Result.then(response => {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
        this.$v.$reset();
        this.responseData = response;
      }).catch(err => {
        this.isLoading = false;
        this.submiting = false;
        return [err];
      });
    },
    addVoucher() {
      this.addVoucherApiCall();
      (this.form.voucherType = null),
        (this.form.voucherNumber = null),
        (this.form.isUnlimitedVoucher = false);
    }
  }
};
</script>

<style scoped>
</style>
